import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { LABS } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={LABS} id={id} />;
}

export const Route = createFileRoute("/_app/departments/labs/$id")({
  component: Edit,
});
